import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import {
  Grid,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
} from '@mui/material';
import CurrencyComponent from '../../../../../shared/components/Currency/Currency';
import { CONFIG_APP } from '../../../../../shared/const/app.config';

const PaymentsTable = ({ payments, policyDetails }) => {
  const { t } = useTranslation();
  return (
    <Grid item xs={12} className="transactions-container">
      <h4>{t('POLICY_DETAILS.PAYMENT.transactions')}</h4>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.transactionType')}</TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.transactionDate')}</TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.transactionId')}</TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.amount')}</TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.status')}</TableCell>
            <TableCell className="message-cell">
              {t('POLICY_DETAILS.PAYMENT.message')}
            </TableCell>
            <TableCell>{t('POLICY_DETAILS.PAYMENT.businessUnitId')}</TableCell>
            <TableCell>
              {t('POLICY_DETAILS.PAYMENT.claimedAgentUserId')}
            </TableCell>
          </TableHead>
          <TableBody>
            {payments.map((payment, index) => (
              <TableRow key={index}>
                <TableCell>
                  {t(`POLICY_DETAILS.PAYMENT.${payment.transactionType}`)}
                </TableCell>
                <TableCell>
                  {format(
                    new Date(payment.createdDate),
                    CONFIG_APP.DATE_FORMAT,
                  )}
                </TableCell>
                <TableCell>{payment.transactionId}</TableCell>
                <TableCell>
                  <CurrencyComponent
                    value={payment.amount}
                    countryCode={policyDetails.policy.price.currency}
                  />
                </TableCell>
                <TableCell>{payment.status}</TableCell>
                <TableCell className="message-cell">
                  {payment.message}
                </TableCell>
                <TableCell>{payment.businessUnitId}</TableCell>
                <TableCell>{payment.claimedAgentUserId}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

PaymentsTable.propTypes = {
  policyDetails: PropTypes.object,
  payments: PropTypes.object,
};
export default PaymentsTable;
